import React, { createContext, useContext, useState, useCallback } from "react";

const UnsavedChangesContext = createContext();

export const useUnsavedChanges = () => {
  const context = useContext(UnsavedChangesContext);
  if (!context) {
    return {
      hasUnsavedChanges: false,
      setUnsavedChanges: () => {},
      handleProtectedNavigation: (navigationFn) => navigationFn(), // Default: no protection
    };
  }
  return context;
};

export const UnsavedChangesProvider = ({ children }) => {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const setUnsavedChanges = useCallback((hasChanges) => {
    setHasUnsavedChanges(hasChanges);
  }, []);

  const handleProtectedNavigation = useCallback(
    async (navigationFn) => {
      if (hasUnsavedChanges) {
        const userChoice = window.confirm(
          "Wait! You have unsaved changes in this page.\n\nTo leave the page without saving your changes, Click 'OK'.\n\nTo stay in the page, click 'Cancel'."
        );

        if (userChoice) {
          // User chose to leave without saving
          navigationFn();
        }
        // If user clicked Cancel, do nothing (stay on current page to save)
      } else {
        // No unsaved changes, navigate directly
        navigationFn();
      }
    },
    [hasUnsavedChanges]
  );

  const value = {
    hasUnsavedChanges,
    setUnsavedChanges,
    handleProtectedNavigation,
  };

  return (
    <UnsavedChangesContext.Provider value={value}>
      {children}
    </UnsavedChangesContext.Provider>
  );
};
